import loginLogo from '../../images/login_logo.svg';

import classes from './login.module.css';

const AuthLogo = ({ style }: any) => {
  return (
    <div className={classes.logoContainer}>
      <img
        style={style}
        className={classes.logoImage}
        src={loginLogo}
        alt={'Atom logo'}
      />
    </div>
  );
};

export default AuthLogo;
